import { Pipe, PipeTransform } from '@angular/core';
import { splitBoldAndRegularText } from '../utils/html-parser.util';

@Pipe({
    name: 'extractBold',
    standalone: false
})
export class BoldExtractorPipe implements PipeTransform {
    transform(value: string): { boldText: string; restText: string } {
        return splitBoldAndRegularText(value);
    }
}